import React, { useState, useEffect } from "react";
import Box from "../../components/dashboard/Box";
import Bridge from "../../constants/Bridge";
import Strings from "../../constants/Strings";
import AllDemographicGraph from "../researchData/ecas/AllDemographicGraph";

const Ecas = () => {
  const [totalEcasForms, setTotalEcasForms] = useState(0);
  const [uniqueParticipants, setUniqueParticipants] = useState(0);
  const [getActiveLink, setGetActiveLink] = useState(true);

  useEffect(() => {
    getDashboardData();
  }, []);

  const getDashboardData = () => {
    Bridge.ecas
      .dashboard()
      .then((result) => {
        //log result
        if (result.status === 1) {
          console.log("result.data.total_ecas_forms---->", result.data.total_ecas_forms);
          console.log("result.data.total_unique_participants---->", result.data.total_unique_participants);
          setTotalEcasForms(result.data.total_ecas_forms );
          setUniqueParticipants(result.data.total_unique_participants);
        }
      })
      .catch((err) => {
        console.log("Error: ", err);
      });
  };

  return (
    <div className="mb-4">
      <p
        style={{
          position: "relative",
          fontSize: 32,
          fontFamily: "Open Sans",
          fontWeight: "bold",
          color: "#1A4F83",
          textAlign: "start",
        }}
        className="mb-4 mt-4"
      >
        {Strings.ecasStudy}
      </p>
      <p
        style={{
          position: "relative",
          fontSize: 20,
          fontFamily: "Open Sans",
          fontWeight: "bold",
          color: "#1A4F83",
          textAlign: "start",
        }}
        className="mb-4"
      >
        {Strings.realTimeStatastics}
      </p>
      <div
        style={{
          backgroundColor: "white",
          padding: "2%",
          borderRadius: "19px",
          maxWidth: "100%",
          alignItems: "center",
        }}
      >
        <div className="row" style={{ padding: "2%" }}>
          <p
            style={{
              position: "relative",
              fontSize: 20,
              fontFamily: "Open Sans",
              fontWeight: "bold",
              color: "#1A4F83",
              textAlign: "start",
            }}
            className="mb-4 block-heading"
          >
            Status: Ongoing and enrolling
          </p>
          <div className="col-lg-3">
            <a
              href="/ecas/list"
              style={{
                fontWeight: "regular",
                fontSize: "18",
              }}
              className={`active-links ${getActiveLink ? "active" : ""}`}
            >
              <Box
                title="ECAS Sessions"
                count={totalEcasForms}
                getActiveLink={getActiveLink}
              />
            </a>
          </div>
          <div className="col-lg-3">
            <a
              href="#!"
              style={{
                fontWeight: "regular",
                fontSize: "18",
                cursor: "auto",
              }}
            >
              <Box
                title="Unique Participants"
                count={uniqueParticipants}
                getActiveLink={false}
              />
            </a>
          </div>
        </div>
        <br />
        <hr style={{ width: "94%", margin: "0 auto" }} />
        <div className="row" style={{ padding: "2%" }}>
          <div className="col-lg-12">
            <AllDemographicGraph />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ecas;
